import { Stack } from "@mui/material";
import React from "react";
import Loading from "../ui/Loading/Loading";

interface IProps {}

export const FullScreenLoading = ({}: IProps): React.ReactElement<IProps> => {
  return (
    <Stack
      width="100%"
      minHeight="100vh"
      alignItems="center"
      justifyContent="center"
    >
      <Loading />
    </Stack>
  );
};

export default FullScreenLoading;
